import { Theme } from '@mui/material/styles'

// ----------------------------------------------------------------------

// eslint-disable-next-line import/prefer-default-export
export function typography(theme: Theme) {
  return {
    MuiTypography: {
      styleOverrides: {
        paragraph: {
          marginBottom: theme.spacing(2)
        },
        gutterBottom: {
          marginBottom: theme.spacing(1)
        }
      }
    }
  }
}
